ixModuleRouting("impactx.opengovernmentdata", {
    "/enforcementarealist": {
        template: "<ixa-enforcement-area-list></ixa-enforcement-area-list>",
        process: "OpenGovernmentDataAdministration",
        workspace: "admin",
    },
    "/companysizelist": {
        template: "<ixa-company-size-list></ixa-company-size-list>",
        process: "OpenGovernmentDataAdministration",
        workspace: "admin",
    },
    "/tenderthresholdlist": {
        template: "<ixa-tender-threshold-list></ixa-tender-threshold-list>",
        process: "OpenGovernmentDataAdministration",
        workspace: "admin",
    },
    "/tenderthreshold/:id": {
        template: "<ixa-tender-threshold></ixa-tender-threshold>",
        process: "TenderThresholdList",
        workspace: "admin",
    },
    "/secondprocurementgrouplist": {
        template: "<ixa-second-procurement-group-list></ixa-second-procurement-group-list>",
        process: "SecondProcurementGroup",
        workspace: "admin",
    },
    "/secondprocurementgroup/:id": {
        template: "<ixa-second-procurement-group></ixa-second-procurement-group>",
        process: "SecondProcurementGroup",
        workspace: "admin",
    },
    // Zwischenseite des eForms-Absprungs. Sie haengt an einer Bestellung, deshalb Workspace "shop"
    // und nicht "admin" wie die uebrigen Routen dieses Moduls.
    // Kein noSecurity: alle drei Einstiege (Button, Postfach, E-Mail nach dem osu-Redirect) sind
    // beim Aufruf angemeldet. Kein process: die eigentliche Pruefung "darf dieser Benutzer DIESE
    // Bestellung bekanntgeben" macht der Endpoint; die Seite zeigt sonst ihren Fehlerzustand.
    "/eformshandoff/:pohId": {
        template: "<ixa-eformshandoff></ixa-eformshandoff>",
        workspace: "shop",
    },
});
